import axiosClient from '../axiosClient';

export const getStaffRoles = (params) =>
  axiosClient.get('/admin/staff-roles', { params });

export const getStaffRole = (id) =>
  axiosClient.get(`/admin/staff-roles/${id}`);

export const createStaffRole = (data) =>
  axiosClient.post('/admin/staff-roles', data);

export const updateStaffRole = (id, data) =>
  axiosClient.put(`/admin/staff-roles/${id}`, data);

export const deleteStaffRole = (id) =>
  axiosClient.delete(`/admin/staff-roles/${id}`);
